import type { IProperty } from "@app/property/types";

export const getShortId = (id: string | null): string | null => {
    if (!id) {
        return null;
    }

    if (id.length < 8) {
        throw new Error("getShortId is used with valid UUIDs only");
    }

    return id.split("-")[4];
};
export const matchShortId = (shortId: string, uuid: string): boolean => uuid.split("-")[4] === shortId;
export const getFullId = (shortId: string, type: "room" | "package" | "rate" | "extra" | "filter", property: IProperty): string | null => {
    const key = `${type}s`;

    if (!shortId) {
        return null;
    }

    if (type === "filter") {
        return property.filter_groups.flatMap((fg) => fg.filters).find((f) => matchShortId(shortId, f.id))?.id || null;
    }

    return property[key].map((r: any) => r.id).find((id: string) => matchShortId(shortId, id)) || null;
};
